import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '../../shared/shared.module';
import { AppUiModule } from '../../ui/app-ui.module';

// New components for tickets-assign-new
import {
  TicketsServicesComponent as TicketsServicesNewComponent,
  ServicesModalComponent as ServicesModalNewComponent,
} from './work-shift/components/tickets-assign-new/components/tickets-services/tickets-services.component';
import { TicketsExtraComponent as TicketsExtraNewComponent } from './work-shift/components/tickets-assign-new/components/tickets-extra/tickets-extra.component';
import { TicketCommunicatorInfoComponent as TicketCommunicatorInfoNewComponent } from './work-shift/components/tickets-assign-new/components/ticket-communicator-info/ticket-communicator-info.component';

@NgModule({
    imports: [CommonModule, AppUiModule, SharedModule],
    declarations: [TicketsServicesNewComponent, ServicesModalNewComponent, TicketsExtraNewComponent, TicketCommunicatorInfoNewComponent],
    exports: [TicketsServicesNewComponent, ServicesModalNewComponent, TicketsExtraNewComponent, TicketCommunicatorInfoNewComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class WorkShiftNewComponentsModule {}
